import { render, staticRenderFns } from "./AdminSuperApply.vue?vue&type=template&id=13b2b624&scoped=true&"
import script from "./AdminSuperApply.vue?vue&type=script&lang=js&"
export * from "./AdminSuperApply.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperApply.vue?vue&type=style&index=0&id=13b2b624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b2b624",
  null
  
)

export default component.exports